import QISignTheme from '../../../interfaces/Theme';
import Header from '../Header';
import Section from '../Section';
import Callout from '../Callout';
import Checkbox from '../Checkbox';
import DataList from '../DataList';
import Title from '../Title'
import CreditCard from '../CreditCard';
import TwoCreditCards from '../TwoCreditCards';
import ProductLabel from '../ProductLabel';

declare type BackendComponent = {
    component: string;
    [key: string]: any;
}

declare type ComponentRendererProps = {
    components: BackendComponent[];
    clientThemeSettings: QISignTheme;
    checkboxState?: Record<number, boolean>;
    onCheckboxChange?: (index: number, checked: boolean) => void;
}

export default function ComponentRenderer({ components, clientThemeSettings, checkboxState, onCheckboxChange }: ComponentRendererProps) {
    const primaryCardTheme = clientThemeSettings.background_color;
    const secondaryCardTheme = clientThemeSettings.button_color;

    return (
        <>
            {components.map((item, index) => {
                if (item.component === 'title') {
                    return <Title title={item.title} />
                }
                if (item.component === 'header') {
                    return <Header key={index} title={item.title} description={item.description} icon={item.icon} clientThemeSettings={clientThemeSettings} />
                }
                if (item.component === 'section') {
                    return <Section key={index} title={item.title} description={item.description} type={item.type} />
                }
                if (item.component === 'callout') {
                    return <Callout key={index} label={item.label} title={item.title} description={item.description} type={item.type} />
                }
                if (item.component === 'checkbox') {
                    return (
                        <Checkbox
                            key={index}
                            title={item.title}
                            description={item.description}
                            required={item.required}
                            checked={checkboxState?.[index] ?? false}
                            onChange={(checked) => onCheckboxChange?.(index, checked)}
                        />
                    )
                }
                if (item.component === 'data_list') {
                    return <DataList key={index} label={item.label} items={item.items} />
                }
                if (item.component === 'credit_card') {
                    return (
                        <CreditCard
                            key={index}
                            title={item.title}
                            cardLabel={item.card_label}
                            type={item.theme}
                            clientThemeSettings={clientThemeSettings}
                        />
                    )
                }
                if (item.component === 'two_credit_cards') {
                    return (
                        <TwoCreditCards
                            key={index}
                            title={item.title}
                            clientThemeSettings={clientThemeSettings}
                            frontlabel={item.front_label}
                            backLabel={item.back_label}
                        />
                    )
                }
                if (item.component === 'product_label') {
                    return (
                        <ProductLabel
                            key={index}
                            title={item.title}
                            theme={item.theme}
                            primaryColor={primaryCardTheme}
                            secondaryColor={secondaryCardTheme}
                        />
                    )
                }
                return null;
            })}
        </>
    )
}
